import { Button, Text } from '@frontend/design-system';
import { drawerHeaderCenterStyles, drawerHeaderStyles } from '../contacts-drawer.styles';

type ContactsDrawerHeaderProps = {
  title: string;
  subtitle?: string;
  count?: number;
  onClose: () => void;
};

export const ContactsDrawerHeader = ({ title, subtitle, count, onClose }: ContactsDrawerHeaderProps) => {
  return (
    <div css={drawerHeaderStyles}>
      <Button iconName='back' variant='secondary' onClick={onClose} />
      <div css={drawerHeaderCenterStyles}>
        <Text size='large' weight='bold'>
          {title}
        </Text>
        {subtitle && (
          <Text size='small' color='light'>
            {subtitle}
          </Text>
        )}
      </div>
      {count ? (
        <Text size='small' color='light'>
          {count}
        </Text>
      ) : null}
    </div>
  );
};
